import type { Components, Theme } from "@mui/material";

export const cssBaselineTheme: Components<Theme>["MuiCssBaseline"] = {
  styleOverrides: (theme) => ({
    body: {
      backgroundColor: theme.palette.background.main,
      color: theme.palette.text.main,
    },
  }),
};
